import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 text-right d-flex justify-content-between" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Create New Asset ")
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" No assets. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Loading assets data. Please wait. ")
const _hoisted_9 = {
  key: 0,
  class: "badge badge-info"
}
const _hoisted_10 = {
  key: 1,
  class: "badge badge-dark"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { class: "form-group text-left" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { for: "id" }, " Asset ", -1)
const _hoisted_17 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_19 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_20 = { class: "col-6" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { for: "coingecko" }, "Coingecko TAG", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_25 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_26 = { class: "text-right" }
const _hoisted_27 = {
  key: 1,
  class: "input-group mb-3"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = { class: "form-group text-left" }
const _hoisted_31 = /*#__PURE__*/_createVNode("label", { for: "description" }, " Description ", -1)
const _hoisted_32 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_33 = { class: "col-4" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", { for: "" }, " Currency Type ", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_36 = { class: "form-check form-check-inline" }
const _hoisted_37 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "crypto"
}, "CRYPTO", -1)
const _hoisted_38 = { class: "form-check form-check-inline" }
const _hoisted_39 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "fiat"
}, "FIAT", -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_41 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_42 = { class: "col-4" }
const _hoisted_43 = /*#__PURE__*/_createVNode("label", { for: "" }, " Options ", -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_45 = { class: "form-check form-check-inline" }
const _hoisted_46 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "vault"
}, "Vault", -1)
const _hoisted_47 = { class: "form-check form-check-inline" }
const _hoisted_48 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "stalk"
}, "Stake", -1)
const _hoisted_49 = { class: "form-check form-check-inline" }
const _hoisted_50 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "lend"
}, "Lend", -1)
const _hoisted_51 = { class: "col-4" }
const _hoisted_52 = { class: "form-group text-left" }
const _hoisted_53 = /*#__PURE__*/_createVNode("label", { for: "description" }, " Decimals: ", -1)
const _hoisted_54 = {
  key: 0,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")
  const _component_AutoComplete = _resolveComponent("AutoComplete")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_CardBase = _resolveComponent("CardBase")

  return (_openBlock(), _createBlock(_component_CardBase, {
    title: "Manage Assets",
    subtitle: "Please provide the required information.",
    allowBack: true
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_DataTable, {
            value: _ctx.filteredItems,
            paginator: true,
            rows: 10,
            rowsPerPageOptions: [10, 20, 50],
            autoLayout: true,
            loading: _ctx.getStatus == 'fetching',
            paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
            currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
          }, {
            header: _withCtx(() => [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control w-50",
                    placeholder: "Search...",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mainSearch = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.mainSearch]
                  ]),
                  _createVNode("button", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addNewAsset && _ctx.addNewAsset(...args))),
                    class: "btn btn-sm btn-sky"
                  }, [
                    _hoisted_5,
                    _hoisted_6
                  ])
                ])
              ])
            ]),
            empty: _withCtx(() => [
              _hoisted_7
            ]),
            loading: _withCtx(() => [
              _hoisted_8
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                header: "Asset",
                bodyStyle: "text-align: left"
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.id), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Description",
                bodyStyle: "text-align: left"
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.description), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Type",
                bodyStyle: "text-align: left"
              }, {
                body: _withCtx((slotProps) => [
                  (slotProps.data.currencyType === 1)
                    ? (_openBlock(), _createBlock("span", _hoisted_9, " FIAT "))
                    : (_openBlock(), _createBlock("span", _hoisted_10, "CRYPTO"))
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Acctions",
                bodyStyle: "text-align: left"
              }, {
                body: _withCtx(({data}) => [
                  _createVNode("button", {
                    onClick: ($event: any) => (_ctx.edit(data)),
                    class: "btn btn-sm btn-warning mr-3"
                  }, [
                    _hoisted_11
                  ], 8, ["onClick"]),
                  _createVNode("button", {
                    onClick: e => _ctx.remove(e, data),
                    class: "btn btn-sm btn-danger"
                  }, [
                    _hoisted_12
                  ], 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "loading"]),
          _createVNode(_component_ConfirmPopup),
          _createVNode(_component_Dialog, {
            header: _ctx.curencyForm.props?.id || 'Add Asset',
            visible: _ctx.showModal,
            "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => (_ctx.showModal = $event)),
            style: { width: '50vw' },
            modal: true,
            onHide: _cache[18] || (_cache[18] = ($event: any) => (_ctx.searchInput = ''))
          }, {
            footer: _withCtx(() => [
              _createVNode("button", {
                disabled: _ctx.curencyForm.invalid,
                class: "btn btn-success",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.saveCurrency && _ctx.saveCurrency(...args)))
              }, " Save ", 8, ["disabled"])
            ]),
            default: _withCtx(() => [
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _withDirectives(_createVNode("input", {
                      onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.inputAsset && _ctx.inputAsset(...args))),
                      id: "id",
                      disabled: _ctx.isEditing,
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.curencyForm.props.id = $event))
                    }, null, 40, ["disabled"]), [
                      [_vModelText, _ctx.curencyForm.props.id]
                    ]),
                    (_ctx.curencyForm.controls.id.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_17, _toDisplayString(_ctx.curencyForm.controls.id.errorMessage), 1))
                      : _createCommentVNode("", true),
                    _hoisted_18,
                    (_ctx.errorCoingecko)
                      ? (_openBlock(), _createBlock("small", _hoisted_19, _toDisplayString(_ctx.errorCoingecko), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _hoisted_22,
                  (_ctx.isEditingCoingecko)
                    ? (_openBlock(), _createBlock("div", _hoisted_23, [
                        _createVNode(_component_AutoComplete, {
                          style: {"width":"100%"},
                          inputStyle: "width:100%",
                          field: "name",
                          modelValue: _ctx.searchInput,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchInput = $event)),
                          suggestions: _ctx.coingeckoCurrencies,
                          onComplete: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fetchCoingeckoCurrencies(_ctx.searchInput))),
                          onItemSelect: _ctx.selectCoingeckoId
                        }, null, 8, ["modelValue", "suggestions", "onItemSelect"]),
                        _hoisted_24,
                        (_ctx.curencyForm.controls.coingeckoId.invalid)
                          ? (_openBlock(), _createBlock("small", _hoisted_25, _toDisplayString(_ctx.curencyForm.controls.coingeckoId.errorMessage), 1))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_26, [
                          (_ctx.isEditing)
                            ? (_openBlock(), _createBlock("small", {
                                key: 0,
                                class: "pointer text-danger",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isEditingCoingecko = false))
                              }, " Cancel "))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_27, [
                        _createVNode("input", {
                          type: "text",
                          class: "form-control",
                          disabled: "",
                          value: _ctx.curencyForm.props.coingeckoObject.name
                        }, null, 8, ["value"]),
                        _createVNode("button", {
                          class: "btn btn-sm btn-outline-warning",
                          type: "button",
                          id: "button-addon2",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isEditingCoingecko = true))
                        }, [
                          _hoisted_28
                        ])
                      ]))
                ]),
                _createVNode("div", _hoisted_29, [
                  _createVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _withDirectives(_createVNode("input", {
                      id: "description",
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.curencyForm.props.description = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.curencyForm.props.description]
                    ]),
                    (_ctx.curencyForm.controls.description.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_32, _toDisplayString(_ctx.curencyForm.controls.description.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _hoisted_35,
                  _createVNode("div", _hoisted_36, [
                    _withDirectives(_createVNode("input", {
                      disabled: _ctx.isEditing,
                      class: "form-check-input",
                      type: "radio",
                      name: "crypto",
                      id: "crypto",
                      value: 0,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.curencyForm.props.currencyType = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelRadio, _ctx.curencyForm.props.currencyType]
                    ]),
                    _hoisted_37
                  ]),
                  _createVNode("div", _hoisted_38, [
                    _withDirectives(_createVNode("input", {
                      disabled: _ctx.isEditing,
                      class: "form-check-input",
                      type: "radio",
                      name: "fiat",
                      id: "fiat",
                      value: 1,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.curencyForm.props.currencyType = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelRadio, _ctx.curencyForm.props.currencyType]
                    ]),
                    _hoisted_39
                  ]),
                  _hoisted_40,
                  (_ctx.curencyForm.controls.currencyType.dirty)
                    ? (_openBlock(), _createBlock("small", _hoisted_41, _toDisplayString(_ctx.curencyForm.controls.currencyType.errorMessage), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _hoisted_44,
                  _createVNode("div", _hoisted_45, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      name: "vault",
                      id: "vault",
                      value: true,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.curencyForm.props.vault = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.curencyForm.props.vault]
                    ]),
                    _hoisted_46
                  ]),
                  _createVNode("div", _hoisted_47, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      name: "stalk",
                      id: "stalk",
                      value: true,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.curencyForm.props.stake = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.curencyForm.props.stake]
                    ]),
                    _hoisted_48
                  ]),
                  _createVNode("div", _hoisted_49, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      name: "lend",
                      id: "lend",
                      value: true,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.curencyForm.props.lend = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.curencyForm.props.lend]
                    ]),
                    _hoisted_50
                  ])
                ]),
                _createVNode("div", _hoisted_51, [
                  _createVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _withDirectives(_createVNode("input", {
                      type: "number",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.curencyForm.props.exact = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.curencyForm.props.exact]
                    ]),
                    (_ctx.curencyForm.controls.exact.invalid)
                      ? (_openBlock(), _createBlock("small", _hoisted_54, _toDisplayString(_ctx.curencyForm.controls.exact.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["header", "visible"])
        ])
      ])
    ]),
    _: 1
  }))
}